import ActionUtility from "../../utilities/ActionUtility";
import TagEffect from "./TagEffect";

export default class TagAction {
  // TAG action with an function declaration
  static REQUEST_TAG = "TAGAction.REQUEST_TAG";
  static REQUEST_TAG_FINISHED = "TAGAction.REQUEST_TAG_FINISHED";

  // TAG Filter
  static REQUEST_TAG_FILTER = "TAGAction.REQUEST_TAG_FILTER";
  static REQUEST_TAG_FILTER_FINISHED = "TAGAction.REQUEST_TAG_FILTER_FINISHED";

  // METHODS
  // TAG GET function
  static requestTag(params) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        TagAction.REQUEST_TAG,
        TagEffect.requestTag,
        params
      );
    };
  }

  // TAG Filter Method
  static requestTagFilter(params) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        TagAction.REQUEST_TAG_FILTER,
        TagEffect.requestTagFilter,
        params
      );
    };
  }
}
